import React, { useState } from 'react';
import CalculatedField from '../CalculatedField';
import PieChart from './PieChart';
import Diagram from './DiagramSection';
// import StackedChart from './StackedChart';
import BarGraph from './BarGraph';

export default function ChartSection({ section, data }) {
  const { schema, chartSchema, sectionLabel, percentageValue, annualValue } =
    section;
  const dropDownFields = schema.filter((field) => field.dropDown);
  const initDropDowns = !dropDownFields.length
    ? null
    : dropDownFields.reduce((acc, field) => {
        acc[field.name] = false;
        return acc;
      }, {});
  const [dropDowns, setDropDowns] = useState(initDropDowns);

  const handleDropDown = (name) => {
    setDropDowns((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const chartSwitch = (chartSchema) => {
    switch (chartSchema.type) {
      case 'diagram':
        return <Diagram schema={chartSchema.schema} data={data} />;
      case 'bar':
        return (
          <BarGraph
            chartSchema={chartSchema.schema}
            data={data}
            title={chartSchema.title}
          />
        );
      case 'pie':
      default:
        return <PieChart chartSchema={chartSchema} data={data} />;
    }
  };

  return (
    <>
      <section className="rounded-lg relative bg-white">
        <div className="py-4 px-6 border-b border-neutral-100 flex items-center gap-3">
          <h3 className="text-lg font-medium font-serif text-neutral-900">
            {sectionLabel}
          </h3>
        </div>
        <div className="grid sm:grid-cols-2 divide-x divide-neutral-100">
          <div className="px-6 pb-8 pt-6">
            {schema?.map((field, index) => (
              <CalculatedField
                showTopBorder={index > 0}
                key={`${field.name} ${index}`}
                field={field}
                fieldValue={data[field.name]}
                sectionType="chart"
                data={data}
                percentageValue={percentageValue}
                annualValue={annualValue}
                dropDowns={dropDowns}
                handleDropDown={
                  dropDownFields?.find((el) => el.name === field.name)
                    ? handleDropDown
                    : null
                }
              />
            ))}
          </div>
          <div className="px-6 pt-6 pb-8 ">
            <div className="flex items-center justify-center ">
              {chartSwitch(chartSchema)}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
